import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import styled from "styled-components";
import axios from "axios";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import '../../../../css/datagrid.css';
import { useNavigate, useLocation } from "react-router-dom";

const MachineProduceInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectProjectID, setSelectProjectID] = useState('');
    const [selectProjectProductName, setSelectProjectProductName] = useState('');
    const [selectBomID, setSelectBomID] = useState('');
    const [selectBomSearchID, setSelectBomSearchID] = useState('');
    const [selectBomItemName, setSelectBomItemName] = useState('');
    const [selectBomItemCount, setSelectBomItemCount] = useState(0);
    const [projectOption, setProjectOption] = useState([]);
    const [projectRows, setProjectRows] = useState([]);
    const [bomOption, setBomOption] = useState([]);
    const [bomRows, setBomRows] = useState([]);
    const [bomInputRows, setBomInputRows] = useState([]);
    const [bomSearchInputRows, setSearchBomInputRows] = useState([]);
    const [columnsProject, setColumnsProject] = useState([]);
    const [columnVisibilityModel1, setColumnVisibilityModel1] = useState({
        id: false,
        project_name: true,
        product_name: true,
        bom_name: true,
        item_name: true,
        nc_file_yn: false,
        nc_file_path: false,
        nc_file_name: false,
    });
    const [columnsBom, setColumnsBom] = useState([]);
    const [columnVisibilityModel2, setColumnVisibilityModel2] = useState({
        id: false,
        input_item_name: true,
        input_item_count: true,
        input_item_spec: true
    });
    const [ncFileOption, setNcFileOption] = useState([]);
    const [selectNcFile, setSelectNcFile] = useState('');
    const [ncFileContent, setNcFileContent] = useState('');

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(selectProjectID === '' || selectProjectID === 0){
            setSelectProjectProductName('');
            setSelectBomID('');
            setSelectBomItemName('');
            setSelectBomItemCount(0);
        }else{
            var tmpProjectRows = projectRows.filter((data) => String(data.machine_project_id) === String(selectProjectID));
            
            if(tmpProjectRows.length > 0){
                setSelectProjectProductName(tmpProjectRows[0].product_name);
                setSelectBomID(Number(tmpProjectRows[0].bom_id));
                setSelectBomItemName(tmpProjectRows[0].item_name);
                setSelectBomItemCount(Number(tmpProjectRows[0].item_count));
            }else{
                setSelectProjectProductName('');
                setSelectBomID('');
                setSelectBomItemName('');
                setSelectBomItemCount(0);
            }
        }
        
    }, [selectProjectID]);

    useEffect(() => {
        if(selectBomSearchID === '' || selectBomSearchID === 0){
            setSearchBomInputRows([]);
        }else{
            var tmpBomRows = bomRows.filter((data) => String(data.bom_id) === String(selectBomSearchID));
            if(tmpBomRows.length > 0){
                const displayArray = tmpBomRows.map((item, index) => ({ 
                    id: item.input_item_id, 
                    input_item_name: item.input_item_name, 
                    input_item_count: item.input_item_count, 
                    input_item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.input_item_spec, item.input_item_width, item.input_item_depth, item.input_item_height )                }));
                setSearchBomInputRows([ ...new Set((displayArray).map(JSON.stringify)) ].map(JSON.parse));
            }else{
                setSearchBomInputRows([]);
            }
        }
    }, [selectBomSearchID]);

    
    useEffect(() => {
        if(selectBomID === '' || selectBomID === '0'){
            setSelectBomItemName('');
            setSelectBomItemCount(0);
            setBomInputRows([]);
        }else{
            if(selectProjectID === '' || selectProjectID === '0'){
                Swal.fire({
                    title: '<p style="color:red">프로젝트 선택 오류</p>',
                    html: '프로젝트 선택 후 BOM을 해야합니다.',
                    confirmButtonText: '확인'
                });
                setSelectBomID('');
            }else{
                var tmpBomRows = bomRows.filter((data) => String(data.bom_id) === String(selectBomID));
                if(tmpBomRows.length > 0){
                    const displayArray = tmpBomRows.map((item, index) => ({ 
                        input_item_id: item.input_item_id, 
                        input_item_name: item.input_item_name, 
                        input_item_count: item.input_item_count, 
                        input_item_spec: item.input_item_spec
                    }));
                    setSelectBomItemName(tmpBomRows[0].item_name);
                    setSelectBomItemCount(tmpBomRows[0].item_count);
                    setBomInputRows([ ...new Set((displayArray).map(JSON.stringify)) ].map(JSON.parse));
                }else{
                    setSelectBomItemName('');
                    setSelectBomItemCount(0);
                    setBomInputRows([]);
                }
            }
        }
    }, [selectBomID]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
        }
    }, [MenuID]);

    useEffect(() => {
        if (!selectNcFile) {
            setNcFileContent('');
            return;
        }
        const selectedItem = ncFileOption.find(opt => String(opt.value) === String(selectNcFile));
        if (selectedItem) {
            setNcFileContent('NC 코드를 불러오는 중입니다...');
            // 👇 바로 아랫줄! newSearchParams -> new URLSearchParams 로 수정되었습니다!
            axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
                fileName: selectedItem.name, // 실제 파일명 (O0406.NC)
                fileNameSever: selectedItem.value // 실제 경로
            }), { withCredentials: true, responseType: 'blob' })
            .then(async (response) => {
                if (response.status === 200) {
                    const text = await response.data.text();
                    setNcFileContent(text);
                } else {
                    setNcFileContent('파일을 불러올 수 없습니다.');
                }
            })
            .catch((error) => {
                setNcFileContent('파일 로드 중 오류가 발생했습니다.');
            });
        }
    }, [selectNcFile]);

    const handleSetting = () => {
        setColumnsProject([
            {
                field: 'download',
                headerName: '다운로드',
                width: 90,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    ((params.row.nc_file_yn === "Y")
                        ? <GridActionsCellItem icon={<DownloadIcon color={"primary"} />} onClick={() => { fileDownloadClick(params) }} label="Download" sx={{ cursor: 'pointer' }} />
                        : <GridActionsCellItem icon={<DownloadIcon color={"disabled"} />} label="Download" disabled sx={{ cursor: 'not-allowed' }} />
                    ),
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'id', headerName: 'machine_project_id', width: 0, headerAlign: 'center' },
            { field: 'project_name', headerName: '프로젝트명', width: 120, headerAlign: 'center', align:'center' },
            { field: 'product_name', headerName: '프로젝트 제품명', width: 200, headerAlign: 'center', align:'left' },
            { field: 'bom_name', headerName: 'BOM', width: 150, headerAlign: 'center', align:'left' },
            { field: 'item_name', headerName: '품명', width: 150, headerAlign: 'center', align:'left' },
            { field: 'item_spec', headerName: '규격', width: 200, headerAlign: 'center', align:'left' },
            { field: 'nc_file_yn', headerName: 'nc_file_yn', width: 0, headerAlign: 'center', align:'left' },
            { field: 'nc_file_path', headerName: 'nc_file_path', width: 0, headerAlign: 'center', align:'left' },
            { field: 'nc_file_name', headerName: 'nc_file_name', width: 0, headerAlign: 'center', align:'left' },
        ]);

        setColumnsBom([
            { field: 'id', headerName: 'machine_project_id', width: 0, headerAlign: 'center' },
            { field: 'input_item_name', headerName: '품명', width: 150, headerAlign: 'center', align:'left' },
            { field: 'input_item_count', headerName: '수량', width: 70, headerAlign: 'center', align:'right' },
            { field: 'input_item_spec', headerName: '규격', width: 250, headerAlign: 'center', align:'left' }
        ]);
    };

    // ★ 로직 수정: 데이터 그룹핑 및 nc_files 배열화
    const handleInitSelect = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        console.log("🚀 [STEP 1] API 다중 호출 시작...");

        // 두 개의 API 호출을 변수에 담습니다.
        const reqSelect = axios.get('/api/p/MachineProduce/Select');
        const reqBom = axios.get('/api/p/MachineProduce/BomList');

        // Promise.all로 두 API가 모두 도착할 때까지 기다립니다.
        Promise.all([reqSelect, reqBom])
        .then(([resSelect, resBom]) => {
            
            // ==========================================
            // 1. Select API (프로젝트) 처리 로직
            // ==========================================
            console.log(`✅ [STEP 2] Select 응답 완료. (원본: ${resSelect.data.length}개)`);
            const projectMap = new Map();
            
            resSelect.data.forEach((item, index) => {
                let key = item.project_name; 
                if (!key) {
                    key = `이름없음_${item.machine_project_id || index}`;
                }

                if (!projectMap.has(key)) {
                    projectMap.set(key, {
                        id: key, 
                        machine_project_id: item.machine_project_id,
                        project_number: item.project_number,
                        project_name: item.project_name || key,
                        product_name: item.product_name || "",
                        bom_id: item.bom_id || "", 
                        bom_name: item.bom_name || "",
                        item_id: item.item_id || "",
                        item_name: item.item_name || "",
                        item_type_name: item.item_type_name || "",
                        item_division_name: item.item_division_name || "",
                        item_count: item.item_count || "0",
                        item_spec: appStore.ITEM_FULL_SPEC_MAKE(
                            item.item_spec || '', item.item_width || '', 
                            item.item_depth || '', item.item_height || ''
                        ),
                        item_width: item.item_width,
                        item_height: item.item_height,
                        item_depth: item.item_depth,
                        nc_file_yn: item.nc_file_yn || 'N',
                        nc_files: [] 
                    });
                }

                const row = projectMap.get(key);
                if (!row.bom_id && item.bom_id) {
                    row.bom_id = item.bom_id;
                    row.bom_name = item.bom_name;
                }
                
                if (item.nc_file_yn === 'Y' && item.nc_file_path) {
                    row.nc_file_yn = 'Y';
                    const isExist = row.nc_files.some(f => f.value === item.nc_file_path);
                    if (!isExist) {
                        row.nc_files.push({
                            value: item.nc_file_path,
                            name: item.nc_file_name,
                            label: item.machine_name || "알 수 없음"
                        });
                    }
                }
            });

            const uniqueProjectRows = Array.from(projectMap.values()).map((row, index) => {
                // 기존 데이터를 유지하되, DataGrid용 id만 절대 중복 불가능한 값으로 덮어씌움
                return {
                    ...row,
                    id: `UID_${index}_${row.machine_project_id}` // 예: UID_0_55, UID_1_87 ...
                };
            });
            
            setProjectRows(uniqueProjectRows);
            console.log(`✅ [STEP 3] 프로젝트 압축 완료. (화면에 출력될 최종 개수: ${uniqueProjectRows.length}줄)`);
            
            const optionArray = uniqueProjectRows.map((item) => 
                ({ value: item.machine_project_id, label: item.project_name + (item.product_name ? ' / ' + item.product_name : '') })
            );
            optionArray.unshift({ value: 0, label : '프로젝트 / 제품명'});
            setProjectOption(optionArray);
            
            setNcFileOption([]);
            setSelectNcFile('');
            setNcFileContent('');


            // ==========================================
            // 2. BomList API (BOM 자재) 처리 로직
            // ==========================================
            console.log(`✅ [STEP 4] BomList 응답 완료. (원본: ${resBom.data.length}개)`);
            const bomOptionMap = new Map();
            const bomGridMap = new Map();
            
            resBom.data.forEach((item) => {
                if (!bomOptionMap.has(item.bom_id)) {
                    bomOptionMap.set(item.bom_id, {
                        value: item.bom_id, 
                        label: item.bom_name + (item.item_name ? ' / ' + item.item_name : '') + (item.item_count ? ' / ' + item.item_count : '')
                    });
                }
                
                const gridKey = `${item.bom_id}_${item.input_item_id}`;
                if (!bomGridMap.has(gridKey)) {
                    bomGridMap.set(gridKey, {
                        bom_id: item.bom_id, bom_name: item.bom_name,
                        item_id: item.item_id, item_name: item.item_name || "",
                        item_type_name: item.item_type_name || "", item_division_name: item.item_division_name || "",
                        item_count: item.item_count || "0", item_spec: item.item_spec || "",
                        item_width: item.item_width || "", item_height: item.item_height || "", item_depth: item.item_depth || "",
                        input_item_id: item.input_item_id || "", input_item_name: item.input_item_name || "",
                        input_item_type_name: item.input_item_type_name || "", input_item_division_name: item.input_item_division_name || "",
                        input_item_count: item.input_item_count || "", input_item_spec: item.input_item_spec || "",
                        input_item_width: item.input_item_width || "", input_item_height: item.input_item_height || "", input_item_depth: item.input_item_depth || ""
                    });
                }
            });

            const finalBomOption = Array.from(bomOptionMap.values());
            finalBomOption.unshift({ value: 0, label : 'BOM / 생산품목명 / 생산수량'});
            setBomOption(finalBomOption);
            
            const finalBomRows = Array.from(bomGridMap.values());
            setBomRows(finalBomRows);
            console.log(`✅ [STEP 5] BOM 압축 완료. (그리드 총 자재: ${finalBomRows.length}줄)`);

        })
        .catch((error) => {
            console.error("❌ API 동시 호출 중 에러 발생:", error);
            appStore.capture();
        })
        .finally(() => {
            // 🚨 이제 두 데이터가 모두 화면에 그려진 뒤에 로딩 스피너가 예쁘게 꺼집니다.
            appStore.setLoading(false);
            console.log("🏁 [STEP 6] 모든 데이터 로딩 및 화면 렌더링 완료.");
        });
    };

    // ★ 로직 추가: 그리드 Row 클릭 이벤트
    const handleProjectRowClick = (params) => {
        const row = params.row;
        
        // 1. 우측 하단 BOM 업데이트
        setSelectBomSearchID(row.bom_id || '');

        // 2. 우측 상단 NC 콤보박스 업데이트
        if (row.nc_files && row.nc_files.length > 0) {
            setNcFileOption(row.nc_files);
            setSelectNcFile(row.nc_files[0].value); // 첫 번째 파일 자동 선택
        } else {
            setNcFileOption([]);
            setSelectNcFile('');
            setNcFileContent('등록된 NC 파일이 없습니다.');
        }
    };

    const handleSave = () => {
        if(selectProjectID === '' || selectProjectID === 0){
            Swal.fire({
                title: '<p style="color:red">프로젝트 저장 오류</p>',
                html: '프로젝트가 선택되지 않았습니다.',
                confirmButtonText: '확인'
            });
        }else if(selectProjectProductName === ''){
            Swal.fire({
                title: '<p style="color:red">프로젝트 저장 오류</p>',
                html: '프로젝트 제품명이 입력되지 않았습니다.',
                confirmButtonText: '확인'
            });
        }else{
            if (appStore.loading) return;
            appStore.setLoading(true);

            axios.post("/api/p/MachineProduce/Update", new URLSearchParams({
                machine_project_id: selectProjectID,
                product_name: selectProjectProductName,
                bom_id: selectBomID
             }),
             { withCredentials: true })
            .then(function (response) {
                if(response.status === 200){
                    Swal.fire({
                        title: '프로젝트 저장 완료',
                        text: '정상적으로 저장되었습니다.',
                        confirmButtonText: '확인',
                        timer:5000,
                        timerProgressBar: true
                    });
                    handleInitSelect();
                }
            })
            .catch(function (error) {
            })
            .finally(() => {
                appStore.setLoading(false); 
            });
        }
    };

    // ★ 로직 수정: 파일 다운로드 (단일 다운로드 or 서버 ZIP 연동)
    const fileDownloadClick = (object) => {
        const ncFiles = object.row.nc_files || [];
        if (ncFiles.length === 0) return;

        if (ncFiles.length === 1) {
            const file = ncFiles[0];
            axios.post('/api/SaveCommon/FileDownload', new URLSearchParams({
                fileName: file.name,
                fileNameSever: file.value
            }),
            { withCredentials: true, responseType: 'blob' })
            .then(function (response) {
                if(response.status === 200){
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", file.name);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }else{
                    appStore.capture();
                }
            })
            .catch(function (error) {
                appStore.capture();
                console.log("네트워크 실패", error);
            });
        } 
        else {
            appStore.setLoading(true);
            axios.post('/api/p/MachineProduce/FileDownloadZip', new URLSearchParams({
                project_name: object.row.project_name
            }), 
            { withCredentials: true, responseType: 'blob' })
            .then(function(response) {
                if(response.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${object.row.project_name}_NCFiles.zip`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    appStore.capture();
                }
            })
            .catch(function (error) {
                appStore.capture();
                console.log("ZIP 다운로드 네트워크 실패", error);
            })
            .finally(() => {
                appStore.setLoading(false);
            });
        }
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
        <div className="menubox" style={ { height:  '70px', paddingRight: '0px' } }>
            <div className="menu-action" style={ { paddingRight: '0px' } }>
                <div className="menu-title">{ MenuName }</div>
                <div className="menu-button">
                    <Button 
                        onClick={ handleSave }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        저장
                    </Button>
                </div>
            </div>
        </div>
        <div className="grid" style={ { top:'73px' } }>
            <div style={ {  width: '100%' } }>
                <div className="grid_sub" style={ {  width: '320px', height: 'calc(100vh - 173px)', float: 'right', paddingLeft: '10px', paddingRight: '10px', backgroundColor: '#f5f5f5', borderRadius:'5px' } }>
                    <div className="menu-keyword-sub-keyword" style={ {  display:'block', float: 'none', maxWidth: '300px', paddingTop: '10px' } }>
                        <select className="modal_filed_input_select" style={ { border:'2px solid lightgrey', borderRadius: '5px', fontSize:'17px', width: '293px' } } placeholder="프로젝트" value={selectProjectID} onChange={(e) => setSelectProjectID(e.target.value) }>
                            {projectOption.map((item, index) => (
                                <option key={index} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </div>

                    <div className="menu-keyword-sub-keyword" style={ {  display:'block', float: 'none', maxWidth: '300px', paddingTop: '10px' } }>
                        <input type="text" placeholder="프로젝트 제품명" style={ { width: '293px' } } value={selectProjectProductName} onChange={(e) => setSelectProjectProductName(e.target.value) } />
                    </div>
                    
                    <div className="menu-keyword-sub-keyword" style={ {  display:'block', float: 'none', maxWidth: '300px', paddingTop: '10px' } }>
                        <select className="modal_filed_input_select" style={ { border:'2px solid lightgrey', borderRadius: '5px', fontSize:'17px', width: '293px' } } placeholder="BOM" value={selectBomID} onChange={(e) => setSelectBomID(e.target.value) }>
                            {bomOption.map((item, index) => (
                                <option key={index} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </div>

                    <div style={ {  display:'block', float: 'none' } }>
                        <p style={ { fontSize: '24px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>BOM 사용 품목</p>
                    </div>

                    <div style={ {  display:'block', float: 'none' } }>
                        {bomInputRows.map((item, index) => (
                            <div key={index} style={ { paddingBottom: '10px', width: '290px' } }>
                                <span style={ { fontSize: '18px' } }>{ item.input_item_name}</span> <span style={ { fontSize: '15px' } }>{item.input_item_spec}</span>
                                <span style={ { float: 'right', fontSize: '18px' } }>{ item.input_item_count }</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="grid_sub" style={ { width: '940px', height: 'calc(100vh - 173px)', float: 'left' } }>
                    <div style={ { padding:'5px', fontSize: '24px', fontWeight: 'bold', height: '45px', marginLeft: '10px' } }>프로젝트(NC)</div>
                    <div style={ { height: 'calc(100vh - 218px)', paddingLeft: '5px', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={projectRows}
                            columns={columnsProject}
                            onRowClick={handleProjectRowClick}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel1}
                            AlternatingRowBackground="LavenderBlush"
                            initialState={{
                                pagination: { paginationModel: { pageSize: 100 } },
                            }}
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
                <div className="grid_sub" style={ { width: 'calc(100% - 1260px)', height: 'calc(100vh - 173px)', float: 'left', paddingLeft: '5px' } }>
                    <div style={ { display:'flow-root', height: '45px', paddingRight: '5px' } }>
                        <div style={ { padding:'5px', paddingLeft: '0px', fontSize: '24px', fontWeight: 'bold', height: '30px', float:'left' } }>NC코드 / BOM</div>
                        <div className="menu-keyword-sub-keyword" style={ {  display:'block', float: 'none', maxWidth: '300px', paddingTop: '5px', float:'right' } }>
                            <select 
                                className="modal_filed_input_select" 
                                style={ { width: '100%', paddingLeft: '10px', border:'2px solid lightgrey', borderRadius: '5px', fontSize:'15px', height: '35px', marginBottom: '5px' } } 
                                value={selectNcFile} 
                                onChange={(e) => setSelectNcFile(e.target.value)}
                            >
                                <option value="">설비명</option>
                                
                                {ncFileOption.map((item, index) => (
                                    <option key={index} value={item.value}>{item.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div style={{ paddingRight: '5px' }}>
                        <textarea 
                            value={ncFileContent} 
                            readOnly 
                            style={{ width: '100%', height: 'calc((100vh - 225px) / 2)', padding: '10px', fontSize: '14px', fontFamily: 'monospace', border: '2px solid lightgrey', borderRadius: '5px', resize: 'none', backgroundColor: '#fdfdfd', outline: 'none', boxSizing: 'border-box' }} 
                        />
                    </div>

                    <div style={{ paddingRight: '5px' }}>
                        <div style={ { height: 'calc((100vh - 225px) / 2)', fontSize: '17px' } }>
                            <DataGrid
                                className="datagrid grid_main"
                                rows={bomSearchInputRows}
                                columns={columnsBom}
                                slots={{
                                    noRowsOverlay: GridNoRow,
                                }}
                                columnVisibilityModel={columnVisibilityModel2}
                                AlternatingRowBackground="LavenderBlush"
                                initialState={{
                                    pagination: { paginationModel: { pageSize: 100 } },
                                }}
                                rowsPerPageOptions={[20, 50, 100]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default MachineProduceInfo;